<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NldTOU/tc-custom/9781398421585.jpg?1705056320663" alt="This image is the cover for the book We Don't Live There!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">We Don't Live There!
      </h1>
      <p class="bookDescription body article font2">
        <p>A bee living in the sea? A penguin in a pig sty? And what about that poor tiger stuck in a bee hive?! That’s not right! These poor animals are living in the wrong homes – so where do they really live…? Find out what other animals have got themselves mixed up and in the wrong habitat, and where they really belong. After all, it’s just too cold for a poor mole down in Antarctica, isn’t it? And pigs wouldn’t do very well living underground, would they? Where should a whale really live? In the ocean...or in the jungle with the monkeys and big cats?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Armitage
      </h2>
      
      <p class="authorDescription body article">Rachel Armitage is originally from Wolverhampton and is a former magazine and newspaper journalist. She lives in rural Lincolnshire with her husband and two children. This is her debut children’s book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53263ec3